<template lang="pug">
div
    .p-a-sm.white.lt.box-shadow
        .pull-right.m-t-sm
            button.md-btn.md-raised.m-b-sm.w-xs.white.m-r-sm(
                :disabled="onLoading('save-user')",
                @click="cancel",
            ) Cancel

            button.md-btn.md-raised.m-b-sm.w-xs.green(
                :disabled="onLoading('save-user') && !canUpdate",
                @click="submit",
            )
                v-loading(loader="save-user") Create

        nav(aria-label="breadcrumb")
            ol.breadcrumb.white.m-b-0.p-b-0
                li.breadcrumb-item
                    router-link(to="/") User Management
                li.breadcrumb-item.active Create
    .padding
        .box
            .box-header.dker
                h3 New User
            .box-divider.m-a-0
            .box-body
                .row
                    .col-md-6
                        .p-a
                            include user-form
</template>

<script>
import userMixin from './user-mixin';

export default {
    $_veeValidate: {
        validator: 'new',
    },

    mixins: [userMixin],

    created() {
        this.setUserAttr({ key: 'id', value: null });
        this.setUserAttr({ key: 'name', value: null });
        this.setUserAttr({ key: 'email', value: null });
        this.setUserAttr({ key: 'password', value: null });
        this.setUserAttr({ key: 'outlets', value: [] });
        this.setUserAttr({ key: 'roles', value: [] });
    },

    methods: {
        cancel() {
            this.$router.push('/');
        },

        async submit() {
            if (!(await this.$validator.validate())) {
                return;
            }

            try {
                await this.createUser();
                this.swal();
                this.$router.push('/');
            } catch (e) {
                if (this.hasLaravelErrors(e)) {
                    this.processLaravelErrors(this.$validator, e.response);
                } else {
                    throw e;
                }
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/user/user-create.vue